'use strict';

import resizeStore from '../resize/resize.store';
import {prefixedCSSValue} from '../utils';

const grabbing = prefixedCSSValue('cursor', 'grabbing');
const grab = prefixedCSSValue('cursor', 'grab');


class Marquee extends HTMLElement{
  constructor(self) {
    self = super(self);
    self.init.call(self);
  }
  init() {
    this._isDragEnabled = this.dataset.drag;

    this._isDown = false;
    this._isMove = false;

    const t = +this.dataset.speed;
    this._initialSpeed = !isNaN(t) && t > 0 ? t : 2;
    this._speed = 2;
    this._current = 0;
    this._previousCurrent = 0;
    this._width = 0;
    this._reverse = -1;

    this._downValue = 0;
    this._downX = 0;
    this._downY = 0;

    this.onResize = () => this._onResize();
    this.onAnimate = () => this._onAnimate();

    this.onMouseDown = (e) => this._onMouseDown(e);
    this.onTouchStart = (e) => this._onTouchStart(e);
    this.onMouseUp = (e) => this._onMouseUp(e);
    this.onTouchEnd = (e) => this._onTouchEnd(e);
    this.onMouseMove = (e) => this._onMouseMove(e);
    this.onTouchMove = (e) => this._onTouchMove(e);
  }
  connectedCallback() {
    this._text = this.innerHTML;
    this.innerHTML = '';
    this._inner = document.createElement('div');
    this._inner.classList.add('marquee-inner');
    this._inner.innerHTML = this._text;

    this.appendChild(this._inner);

    let t = this._text.replace(' ', '');

    if (!this._inner.offsetWidth || !this._inner.offsetHeight || !t) {
      console.warn('Нет контента в ', this);
      this.style.visibility = 'hidden';
      return;
    }

    this._lines = [];
    this._itemsCount = 0;


    this._onResize();
    resizeStore.eventEmitter.subscribe(this.onResize);

    if (this._isDragEnabled) {
      this._createDrag();
      this._raf = requestAnimationFrame(this.onAnimate);
    } else {
      this.classList.add('no-drag');
    }

    this.classList.add('started');
  }
  disconnectedCallback() {
    if (this._isDragEnabled) {
      document.documentElement.removeEventListener('mouseup', this.onMouseUp);
      document.documentElement.removeEventListener('touchend', this.onTouchEnd);
      document.documentElement.removeEventListener('touchcancel', this.onTouchEnd);
      document.documentElement.removeEventListener('mousemove', this.onMouseMove);
      document.documentElement.removeEventListener('touchmove', this.onTouchMove);

      document.documentElement.style.cursor = '';
    }

    cancelAnimationFrame(this._raf);
    resizeStore.eventEmitter.unsubscribe(this.onResize);
  }

  _onResize() {
    const w = this.offsetWidth;
    const h = this.offsetHeight;
    const wi = this._inner.offsetWidth;
    const hi = this._inner.offsetHeight;

    this._width = wi;
    this._speed = wi / Math.floor(wi / this._initialSpeed);

    const countW = Math.ceil(w / wi) + 2;
    const countH = Math.ceil(h / hi);

    if (countH > this._lines.length) {
      const size = countH - this._lines.length;

      for (let i = 0; size > i; i ++) {
        const elem = document.createElement('div');
        elem.classList.add('marquee-line');
        this.appendChild(elem);
        this._lines.push({
          elem,
          enabled: true,
          inners: [],
          reverse: this._reverse
        });

        this._reverse *= -1;
      }
    } else {
      this._lines.forEach((line, index) => (line.enabled = index < countH));
    }

    if (countW > this._itemsCount) {
      const size = countW - this._itemsCount;

      this._lines.forEach(line => {
        for (let i = 0; i < size; i++) {
          const clone = this._inner.cloneNode(true);
          line.inners.push(clone);
          line.elem.appendChild(clone);
        }
      })
      this._itemsCount = countW;
    }

    if (!this._isDragEnabled) this.style.setProperty('--time', wi / w * 20 + 's');
  }




  _onMouseDown(e) {
    e.preventDefault();
    this._isDown = true;

    this._downX = e.clientX;
    this._downY = e.clientY;
    this._downValue = e.clientX + this._current;

    document.documentElement.style.cursor = grabbing;
    this.style.cursor = grabbing;
  }
  _onTouchStart(e) {
    // e.preventDefault();
    this._isDown = true;

    const t = e.touches[0];
    this._downX = t.clientX;
    this._downY = t.clientY;

    this._downValue = t.clientX + this._current;
  }

  _onMouseUp(e) {
    if (!this._isDown) return;
    // e.preventDefault();
    this._isDown = false;

    document.documentElement.style.cursor = '';
    this.style.cursor = grab;
  }
  _onTouchEnd(e) {
    if (!this._isDown) return;
    // e.preventDefault();
    this._isDown = false;
    this._isMove = false;
  }

  _onMouseMove(e) {
    if (!this._isDown) return;

    e.preventDefault();
    this._setCurrent(e.clientX - this._downValue);
  }
  _onTouchMove(e) {
    if (!this._isDown) return;

    if (!this._isMove) {
      const t = e.touches[0];
      const x = Math.abs(t.clientX - this._downX);
      const y = Math.abs(t.clientY - this._downY);

      if (x / 2 < y) {
        this._isDown = false;
        return;
      }

      this._isMove = true;
    }


    e.preventDefault();
    this._setCurrent(e.touches[0].clientX - this._downValue);
  }
  _setCurrent(value) {
    this._current = -(value - this._width * Math.floor(value / this._width));
  }
  
  _createDrag() {
    this.style.cursor = grab;

    this.addEventListener('mousedown', this.onMouseDown);
    this.addEventListener('touchstart', this.onTouchStart, {passive: false});
    document.documentElement.addEventListener('mouseup', this.onMouseUp);
    document.documentElement.addEventListener('touchend', this.onTouchEnd, {passive: false});
    document.documentElement.addEventListener('touchcancel', this.onTouchEnd, {passive: false});
    document.documentElement.addEventListener('mousemove', this.onMouseMove);
    document.documentElement.addEventListener('touchmove', this.onTouchMove, {passive: false});
  }
  
  _onAnimate() {
    if (!this._isDown) {
      this._current += this._speed;

      if (this._current > this._width) this._current = 0;
    }

    // console.log(this._current, this._width)

    if (this._current !== this._previousCurrent) {
      this._lines.forEach(line => {
        if (line.enabled) {
          const x = this._current * line.reverse;

          line.elem.style.transform = `translate3d(${x}px, 0, 0)`;
        }
      });

      this._previousCurrent = this._current;
    }

    this._raf = requestAnimationFrame(this.onAnimate);
  }
}

window.customElements.define('marquee-view', Marquee);